import React from 'react'

import styled from 'styled-components'
import AppPage from '../layouts/AppPage'

export default function PageNotFound() {
  return (
    <AppPage>
      <PageNotFoundSection />
    </AppPage>
  )
}

export function PageNotFoundSection() {
  return (
    <SECTION>
      <h2>Страница не найдена</h2>
    </SECTION>
  )
}

const SECTION = styled.section`
  padding: 20px 0 0 24px;

  display: flex;
  flex-direction: column;
  gap: 2rem;

  font-family: var(--primary-font);

  & h2 {
    font-size: 1.125rem;
    font-weight: 700;
  }

  & h3 {
    font-size: 1rem;
    font-weight: 400;
  }

  @media (min-width: 768px) {
    padding-left: 50px;
`;